import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, StatusBadge, fmtDate } from "@/components/shared";
import { Card, CardContent } from "@/components/ui/card";
import { Dog as DogIcon, GraduationCap, User, ArrowRight, Cake, Weight } from "lucide-react";

export default function ClientDogs() {
  const navigate = useNavigate();
  const [dogs, setDogs] = useState([]);
  useEffect(() => { api.get("/client/dashboard").then((r) => setDogs(r.data.dogs)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="My Dogs" subtitle="Your dogs and their training journey." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {dogs.map((d) => (
          <Card key={d.id} className="border-border hover:-translate-y-1 hover:shadow-md transition-all cursor-pointer" onClick={() => navigate(`/dogs/${d.id}`)} data-testid="client-dog-card">
            <CardContent className="p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-2">
                  <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center"><DogIcon size={20} className="text-primary" strokeWidth={1.5} /></div>
                  <div>
                    <div className="font-heading font-semibold text-lg leading-tight">{d.name}</div>
                    <div className="text-sm text-muted-foreground">{d.breed || "—"}</div>
                  </div>
                </div>
                <StatusBadge value={d.current_level} />
              </div>
              <div className="flex items-center gap-4 mt-4 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><Cake size={13} /> {d.age || "—"}</span>
                <span className="flex items-center gap-1"><Weight size={13} /> {d.weight || "—"}</span>
              </div>
              <div className="mt-3 space-y-1.5 text-xs text-muted-foreground">
                <div className="flex items-center gap-1.5"><GraduationCap size={13} /> {d.current_program || "No active program"}</div>
                <div className="flex items-center gap-1.5"><User size={13} /> {d.trainer_name || "Unassigned"}</div>
              </div>
              <div className="mt-4 pt-3 border-t border-border/60 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <StatusBadge value={d.progress_status} />
                  {d.homework_status === "open" && <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 border border-blue-200">Homework due</span>}
                </div>
                <span className="text-xs text-primary font-medium flex items-center gap-1">View journey <ArrowRight size={13} /></span>
              </div>
              {d.next_class && (
                <div className="mt-3 text-xs bg-muted/50 rounded-lg p-2.5">
                  <span className="text-muted-foreground">Next class: </span>
                  <span className="font-medium">{d.next_class.name}</span>
                  <span className="text-muted-foreground"> · {fmtDate(d.next_class.date)}</span>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
        {dogs.length === 0 && <p className="text-muted-foreground col-span-full text-center py-12">No dogs yet.</p>}
      </div>
    </div>
  );
}
